export default __webpack_public_path__ + "static/media/icon_pencil.c635d8ae.svg";